import classNames from "classnames";
import React, { forwardRef, RefObject, useMemo } from "react";
import { Avatar } from "../avatar/avatar";
import { IconNavArrowDown, IconNavArrowUp } from "../icons";
import { IconProps } from "../types";
import { CSS_CLASSES } from "./global-header-css-classes";

export interface GlobalHeaderUserMenuButtonProps {
  variant: "dark" | "light";
  color?: "interactive" | "primary";
  menuOpen?: boolean;
  isDesktop?: boolean;
  firstName: string;
  lastName: string;
}

export const GlobalHeaderUserMenuButton = forwardRef(
  (
    {
      variant,
      color = "interactive",
      menuOpen = false,
      isDesktop = false,
      firstName,
      lastName,
      ...restProps
    }: GlobalHeaderUserMenuButtonProps,
    ref: RefObject<HTMLButtonElement>
  ) => {
    const iconColor: IconProps["color"] = useMemo(() => (variant === "dark" ? color : "white"), [color, variant]);
    const rootClassName = useMemo(
      () =>
        classNames(CSS_CLASSES.GLOBAL_HEADER_USER_MENU_BUTTON, {
          [CSS_CLASSES.GLOBAL_HEADER_USER_MENU_BUTTON_LIGHT]: variant === "light",
          [CSS_CLASSES.GLOBAL_HEADER_USER_MENU_BUTTON_DARK]: variant === "dark",
          [CSS_CLASSES.GLOBAL_HEADER_USER_MENU_BUTTON_PRIMARY]: color === "primary",
          [CSS_CLASSES.GLOBAL_HEADER_USER_MENU_BUTTON_INTERACTIVE]: color === "interactive",
        }),
      [variant, color]
    );
    return (
      <button ref={ref} className={rootClassName} {...restProps}>
        <Avatar variant={variant} color={color} firstName={firstName} lastName={lastName} />
        {isDesktop && (
          <span className={CSS_CLASSES.GLOBAL_HEADER_USER_MENU_BUTTON_END_ICON}>
            {menuOpen ? <IconNavArrowUp color={iconColor} /> : <IconNavArrowDown color={iconColor} />}
          </span>
        )}
      </button>
    );
  }
);
